/* eslint-disable implicit-arrow-linebreak */
export const monetaryUSDFormat = (value: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

export type CurrencyCode = 'USD' | 'INR' | 'EUR' | 'GBP' | 'JPY' | 'AUD' | 'CAD';

export const formatCurrency = (
  value: number | string | null | undefined,
  currency?: CurrencyCode | null | undefined,
  locale?: string,
  fallback = '-'
): string => {
  if (value === null || value === undefined) {
    return fallback;
  }

  const amount = Number(value);

  if (Number.isNaN(amount)) {
    return fallback;
  }

  // ✅ Default currency = USD
  const resolvedCurrency: CurrencyCode = currency ?? 'USD';

  let resolvedLocale = locale;

  if (!resolvedLocale) {
    switch (resolvedCurrency) {
      case 'INR':
        resolvedLocale = 'en-IN';
        break;
      case 'EUR':
        resolvedLocale = 'de-DE';
        break;
      default:
        resolvedLocale = 'en-US';
    }
  }

  return new Intl.NumberFormat(resolvedLocale, {
    style: 'currency',
    currency: resolvedCurrency,
    currencyDisplay: 'symbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};
